"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_FLIGHT_JOURNEY_OPTIONS = void 0;
exports.LIST_FLIGHT_JOURNEY_OPTIONS = {
    USER_NOT_FOUND: {
        usecase: 'LIST_FLIGHT_JOURNEY_OPTIONS',
        type: 'USER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Usuário não encontrado.',
        },
    },
    USER_NOT_BELONG_TO_FLIGHT_CHANGE: {
        usecase: 'LIST_FLIGHT_JOURNEY_OPTIONS',
        type: 'USER_NOT_BELONG_TO_FLIGHT_CHANGE',
        messageLangMap: {
            'PT-BR': 'Não é possível trocar o usuário durante uma solicitação de alteração de voo.',
        },
    },
    FLIGHT_CHANGE_NOT_FOUND: {
        usecase: 'LIST_FLIGHT_JOURNEY_OPTIONS',
        type: 'FLIGHT_CHANGE_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'A alteração de voo não foi encontrada.',
        },
    },
    INCOMPLETE_RESULT: {
        usecase: 'LIST_FLIGHT_JOURNEY_OPTIONS',
        type: 'INCOMPLETE_RESULT',
        messageLangMap: {
            'PT-BR': 'Não foi possível obter o resultado completo da busca. Por favor, tente realizar a busca novamente.',
        },
    },
};
